export const baseFields = {
    date: {
        start_date: {
            label: "Consumption start date",
            errorMsg: "",
            type: "start_date_channels",
            identifier: "start_date",
            default: null,
            required: true,
            datePeriod: {},
            tempStartDate: "",
            hasError: false,
        },
        end_date: {
            label: "Consumption end date",
            type: "end_date_channels",
            errorMsg: "",
            identifier: "end_date",
            default: null,
            required: true,
            editable: true,
            datePeriod: {},
            tempEndDate: "",
            hasError: false,
            disabled: false,
        },
        grouptime: {
            label: "View mode",
            identifier: "grouptime",
            type: "dropdown-grouptime-select",
            options: [
                { label: "Day", id: "day" },
                { label: "7 days (rolling)", id: "sevendays" },
                { label: "Week", id: "week" },
            ],
            datePeriod: {},
            tempGroupTime: "",
        },
        showDateModal: false,
    },
    providers: {
        label: "Channels",
        type: "provider-picker-channels",
        identifier: "provider_keys",
        title: "Channels",
        sites: [],
        channels: [],
        default: [],
        showChannelModal: false,
    },
    target_group: {
        label: "Target group",
        identifier: "target_group",
        type: "target_group_channels",
        config: {},
        showTargetGroupModal: false,
    },
    weekdays: {
        showWeekdayModal: false,
        label: "Week days",
        type: "dropdown-checkboxes-weekdays",
        identifier: "weekdays",
        config: {
          options: [
            {
              value: 1,
              text: "Monday"
            },
            {
              value: 2,
              text: "Tuesday"
            },
            {
              value: 3,
              text: "Wednesday"
            },
            {
              value: 4,
              text: "Thursday"
            },
            {
              value: 5,
              text: "Friday"
            },
            {
              value: 6,
              text: "Saturday"
            },
            {
              value: 7,
              text: "Sunday"
            }
          ]
        },
        default: []
    },
}
